import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { useMediaQuery } from "@mui/material";
import logo from "../../../assets/Images/Logo.png";
import logoDarkMode from "../../../assets/Images/Logo-darkmode.png";
import {
  ResultCarPrice,
  onRoadPriceResult,
  CarPriceInflation,
  carEstimatePrice,
} from "../types";
import Form from "../Form";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";

export default function PermanentDrawerLeft({
  carPriceValue,
  setCarPriceValue,
  setOnRoadPrice,
  setPriceVolatility,
  setCarEstimatedPrice,
  isLoadCarPrice,
  setIsLoadCarPrice,
  setErrorVolatility,
  setErrorEstimated,
  registerPlace,
  onBackToLandingPage,
  jobId,
  setJobId,
}: {
  carPriceValue: ResultCarPrice;
  setCarPriceValue: React.Dispatch<React.SetStateAction<ResultCarPrice>>;
  setOnRoadPrice: React.Dispatch<React.SetStateAction<onRoadPriceResult>>;
  setPriceVolatility: React.Dispatch<React.SetStateAction<CarPriceInflation[]>>;
  setCarEstimatedPrice: React.Dispatch<React.SetStateAction<carEstimatePrice>>;
  isLoadCarPrice: boolean;
  setIsLoadCarPrice: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorVolatility: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorEstimated: React.Dispatch<React.SetStateAction<boolean>>;
  registerPlace: string;
  onBackToLandingPage: () => void;
  jobId: string | null;
  setJobId: React.Dispatch<React.SetStateAction<string | null>>;
}) {
  const isTabletOrMobile = useMediaQuery("(max-width: 1050px)");
  const theme = useTheme();

  const isSmall = useMediaQuery("(max-width: 1200px)");

  const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return width;
  };

  const width = useWindowWidth();

  return !isTabletOrMobile ? (
    <Drawer
      sx={{
        width: isSmall ? 0.3 * width : 0.25 * width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: isSmall ? 0.3 * width : 0.25 * width,
          boxSizing: "border-box",
          borderRight: "none",
          backgroundColor: theme.palette.mode === "dark" ? "#21262C" : "unset",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Box sx={{ paddingY: "24px", paddingX: isSmall ? "0px" : "8px" }}>
        {theme.palette.mode === "dark" ? (
          <img
            src={logoDarkMode}
            alt="logo"
            width={200}
            height={50}
            style={{ marginBottom: "15px", cursor: "pointer", paddingLeft: 12 }}
            onClick={onBackToLandingPage}
          />
        ) : (
          <img
            src={logo}
            alt="logo"
            width={200}
            height={50}
            style={{ marginBottom: "15px", cursor: "pointer", paddingLeft: 12 }}
            onClick={onBackToLandingPage}
          />
        )}
        <Form
          carPriceValue={carPriceValue}
          setCarPriceValue={setCarPriceValue}
          setOnRoadPrice={setOnRoadPrice}
          setPriceVolatility={setPriceVolatility}
          setCarEstimatedPrice={setCarEstimatedPrice}
          isLoadCarPrice={isLoadCarPrice}
          setIsLoadCarPrice={setIsLoadCarPrice}
          setErrorVolatility={setErrorVolatility}
          setErrorEstimated={setErrorEstimated}
          registerPlace={registerPlace}
          jobId={jobId}
          setJobId={setJobId}
        />
      </Box>
    </Drawer>
  ) : null;
}
